var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social"},[_c('a',{attrs:{"href":_vm.media.link,"target":"_blank"}},[_c('i',{class:_vm.media.icon,style:(_vm.color)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }